import React from 'react';
import '../template-file-css/document-file-template.css';


export const AJC_AttendancePolicyConsent = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='AJC_AttendancePolicyConsent' className='file-pdf-document'>

            <div className='file-template'>
                <p className='w-750'><strong>Please initial by each line acknowledging that you have read and understand the following statements.</strong></p>
                <table>
                    <tr>
                        <td className='w-750'> <input type="checkbox" id="cbAttendencePolicyStatements_1" name="cbAttendencePolicyStatements_1" className='add-only' value="AttendencePolicyStatements_1" />
                            Clients must attend weekly sessions with their therapist. Attendance in the program is  mandatory.
                        </td>
                    </tr>
                    <tr>

                        <td className='w-750'> <input type="checkbox" id="cbAttendencePolicyStatements_2" name="cbAttendencePolicyStatements_2" className='add-only' value="AttendencePolicyStatements_2" />
                            A written note from the parent if client miss (3) appointments within one month for one of
                            the following reasons is required: Illness or injury of the child or the child's family
                            member which requires hospitalization or bed rest; Infectious disease or parasitic
                            infestation; Funeral service, memorial service, or bereavement upon the death of the
                            child's family member; Compliance with a court order (e.g. visitation, subpoena); Family
                            vacation, not to exceed 5 excused absences per program  year.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type="checkbox" id="cbAttendencePolicyStatements_3" name="cbAttendencePolicyStatements_3" className='add-only' value="AttendencePolicyStatements_3" />
                            A <strong>Late fee</strong> of $15 will be assessed if you/your child arrives 15 minutes late for the set
                            appointment time and <strong>have not</strong> notified your therapist in advance.
                        </td>

                    </tr>

                    <tr>
                        <td className='w-750'> <input type="checkbox" id="cbAttendencePolicyStatements_4" name="cbAttendencePolicyStatements_4" className='add-only' value="AttendencePolicyStatements_4" />
                            Appointment <strong>Cancellation</strong> must be received 24-hours in advance.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type="checkbox" id="cbAttendencePolicyStatements_5" name="cbAttendencePolicyStatements_5" className='add-only' value="AttendencePolicyStatements_5" />
                            A $25.00 fee will be assessed for all <strong>No-Show</strong> appointments if a prior 24-hour notification
                            is not received.

                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type="checkbox" id="cbAttendencePolicyStatements_6" name="cbAttendencePolicyStatements_6" className='add-only' value="AttendencePolicyStatements_6" />
                            If <strong>three (3)</strong> consecutive therapy sessions are missed without prior notification client will
                            be placed on a probationary fee will be assessed for and /or discharged from the program.

                        </td>
                    </tr>
                </table>
                <p className='w-750'><strong>My signature below is acknowledgement of my review and acceptance of the terms of this policy.</strong> </p>
            </div>
        </form>

    )
}







